<script>
import homeIcon from "@/assets/images/global/home.svg";
import rewardIcon from "@/assets/images/global/reward.svg";
import transactionIcon from "@/assets/images/global/transaction.svg";
import receiptIcon from "@/assets/images/global/receipt.svg";
import userIcon from "@/assets/images/global/user.svg";

export const BANOBAGI_BOTTOM_NAV_ROUTES = [
  "/profile",
  "/benefits",
  "/purchase-history",
  "/receipt",
  "/banobagi/profile"
];

export default {
  name: "BanobagiBottomNavigation",
  props: {
    receiptRoute: {
      type: String,
      default: "/receipt"
    },
    transactionActive: {
      type: Boolean,
      default: false
    }
  },
  emits: ["open-transaction"],
  computed: {
    tabs() {
      return [
        {
          key: "home",
          label: this.$t("home"),
          route: BANOBAGI_BOTTOM_NAV_ROUTES[0],
          icon: homeIcon
        },
        {
          key: "reward",
          label: this.$t("redeem_text"),
          route: BANOBAGI_BOTTOM_NAV_ROUTES[1],
          icon: rewardIcon
        },
        {
          key: "orders",
          label: this.$t("minimal_transaction_tab_title"),
          route: BANOBAGI_BOTTOM_NAV_ROUTES[2],
          icon: transactionIcon
        },
        // {
        //   key: "receipt",
        //   label: this.$t("your_receipt"),
        //   route: this.receiptRoute,
        //   icon: receiptIcon
        // },
        {
          key: "profile",
          label: this.$t("profile"),
          route: BANOBAGI_BOTTOM_NAV_ROUTES[4],
          icon: userIcon
        }
      ];
    }
  },
  methods: {
    isActive(route) {
      const routePath = route.split("?")[0];
      if (routePath === "/profile") return this.$route.path === routePath;
      return (
        this.$route.path === routePath ||
        this.$route.path.startsWith(`${routePath}/`)
      );
    },
    isTabActive(tab) {
      if (this.transactionActive) return tab.key === "orders";
      return this.isActive(tab.route);
    },
    selectTab(tab) {
      this.goTo(tab.route);
    },
    goTo(route) {
      if (!this.isActive(route)) this.$router.push(route);
    }
  }
};
</script>

<template>
  <nav class="banobagi-nav" data-test="footer-nav-banobagi">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      :class="['banobagi-nav__item', { 'is-active': isTabActive(tab) }]"
      :data-test="`footer-nav-${tab.key}-tab`"
      :aria-current="isTabActive(tab) ? 'page' : undefined"
      @click="selectTab(tab)"
    >
      <span
        class="banobagi-nav__icon"
        aria-hidden="true"
        :style="{ '--banobagi-nav-icon': `url(${tab.icon})` }"
      />
      <span class="banobagi-nav__label">{{ tab.label }}</span>
    </button>
  </nav>
</template>

<style lang="scss" scoped>
.banobagi-nav {
  position: fixed;
  bottom: max(32px, env(safe-area-inset-bottom));
  left: 50%;
  z-index: 30;
  display: grid;
  width: calc(100% - 32px);
  max-width: 408px;
  min-height: 78px;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
  align-items: center;
  padding: 0 24px;
  border: 1px solid #4a5057;
  border-radius: var(--crm-border-radius);
  background: #1d242d;
  box-shadow: 0 16px 38px rgba(16, 40, 90, 0.3);
  transform: translateX(-50%);
}

.banobagi-nav__item {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 4px;
  border: 0;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  font: inherit;
}

.banobagi-nav__item:focus-visible {
  border-radius: 18px;
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}

.banobagi-nav__icon {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: currentColor;
  mask-image: var(--banobagi-nav-icon);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  -webkit-mask-image: var(--banobagi-nav-icon);
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  -webkit-mask-size: contain;
  transition: color 0.2s ease, transform 0.2s ease;
}

.banobagi-nav__label {
  overflow: hidden;
  max-width: 100%;
  font-size: var(--font-body);
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.banobagi-nav__item.is-active {
  color: var(--primary-color);
  // font-weight: 600;
}

.banobagi-nav__item.is-active .banobagi-nav__icon {
  // transform: translateY(-2px);
}

@media (max-width: 360px) {
  .banobagi-nav {
    width: calc(100% - 20px);
    min-height: 78px;
  }

  .banobagi-nav__label {
    font-size: var(--font-body-sm);
  }
}
</style>
